import dedent from 'dedent';
import { z } from 'zod';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, zodTDateISODate } from '~/lib/zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';

export type RiderShipping = z.infer<typeof shippingSchema>;

export const holesSchema = z.enum(['2', '4']);

export const shippingSchema = z.enum(['courier', 'ups']);

export default createPerformableConfig(
  'riders',
  {
    [FIRST_VERSION_TIMESTAMP]: z
      .object({
        version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
        holes: holesSchema,
        shipping: shippingSchema.optional(),
        need_by: zodTDateISODate('Need By date is required'),
        no_qr_code: coerceBoolean().optional(),
      }),
  },
  {
    name: 'Sign Riders',
    group: 'Property Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/riders/thumbnail_v2.jpg',
    images: [],
    short: dedent`
      Our 24" x 6" Yard Sign Riders offer a sleek, durable way to enhance your real estate \
      signage. Made from 3mm PVC, they withstand the elements while maintaining a polished \
      look. With 2 or 4 pre-drilled holes for easy mounting, each rider includes a property \
      website link or custom URL (for a fee) and a QR code for instant access to listing \
      details.
    `,
  },
);
